const delivery = {
  breadcrumb: {
    delivery: "Envíos",
    settings: "Configuración de envíos",
    coverage: "Cobertura",
    home: "Mis envíos",
    create: "Nuevo envío",
    checkout: "Confirmar envío",
    detail: "Detalle del envío",
  },
  menu: {
    title: "Envíos",
    description: "Configura y gestiona los envíos de tu tienda",
  },
  settings: {
    title: "Configuración de envíos",
    local: {
      title: "Envío local",
      enabled: "Activar envío local",
      price: "Precio de envío",
      freeShipping: "Envío gratis",
      minOrder: "Pedido mínimo para envío gratis",
    },
    national: {
      title: "Envío nacional",
      enabled: "Activar envío nacional",
      price: "Precio de envío",
      freeShipping: "Envío gratis",
      minOrder: "Pedido mínimo para envío gratis",
    },
    pickup: {
      title: "Recogida en tienda",
      enabled: "Permitir recogida en tienda",
      manageAddress: "Gestionar dirección de tienda",
    },
    estimatedTime: {
      title: "Tiempos estimados de entrega",
      local: "Tiempo local",
      national: "Tiempo nacional",
    },
    coverageLink: "Gestionar cobertura geográfica",
    save: "Guardar configuración",
    saveSuccess: "Configuración guardada",
    saveError: "Error al guardar",
    primeRequired: "Necesitas membresía Prime para activar envío gratis",
  },
  coverage: {
    title: "Cobertura geográfica",
    selectType: "Selecciona el tipo de cobertura",
    local: "Envío local",
    national: "Envío nacional",
    localEnabled: "Activar envío local",
    nationalEnabled: "Activar envío nacional",
    cities: "Ciudades disponibles",
    addCity: "Agregar ciudad",
    cityPlaceholder: "Buscar ciudad",
    noCities: "Agrega al menos una ciudad para activar envío local",
    previewStore: "Ver cómo lo ve el cliente",
    save: "Guardar cobertura",
    saveSuccess: "Cobertura actualizada",
  },
  home: {
    title: "Mis envíos",
    originAddress: "Dirección de origen",
    editAddress: "Editar dirección",
    newShipment: "Nuevo envío",
    newManualShipment: "Envío sin pedido",
    newOrderShipment: "Envío con pedido",
    settings: "Configuración",
    inProgress: "En curso",
    recent: "Recientes",
    empty: "No tienes envíos registrados",
    retry: "Reintentar",
    loadError: "No se pudo cargar el historial",
    orderPicker: {
      title: "Seleccionar pedido",
      empty: "No hay pedidos empaquetados pendientes de envío",
      error: "No se pudieron cargar los pedidos",
      retry: "Reintentar",
    },
  },
  create: {
    title: "Nuevo envío",
    fromOrder: "Desde pedido",
    manual: "Cliente manual",
    origin: "Origen",
    destination: "Destino",
    customerName: "Nombre del cliente",
    customerPhone: "Teléfono",
    customerEmail: "Correo electrónico",
    customerAddress: "Dirección",
    addressDetails: "Complemento de dirección",
    customerCity: "Ciudad",
    deliverySize: "Tamaño del paquete",
    deliveryType: "Tipo de servicio",
    provider: "Proveedor",
    pickupDate: "Fecha de recogida",
    calculate: "Cotizar envío",
    calculateError: "Error al cotizar envío",
    continue: "Continuar al checkout",
    selectProvider: "Selecciona un proveedor",
    validationError: "Completa todos los campos requeridos",
    geocode: "Buscar coordenadas",
    geocodeSuccess: "Dirección encontrada",
    noSizes: "No hay tamaños de paquete configurados. Revisa la configuración de envíos.",
    noProviders: "No hay proveedores disponibles para este tipo de envío.",
    providersEmptyTitle: "No encontramos couriers disponibles",
    providersEmptyMessage:
      "Revisa que tu dirección de origen esté completa y con coordenadas correctas. Puedes actualizarla y volver a cotizar.",
    providersEmptyButton: "Editar dirección de origen",
    goToSettings: "Ir a configuración",
    productsAlertMessage:
      "Indica el *tamaño real* del empaque según las dimensiones de tus productos. Un tamaño incorrecto puede generar *cobros adicionales* por parte del transportador.",
    orderDetail: "Detalle del pedido",
    orderDetailHint: "Describe brevemente qué envías (productos, cantidad, etc.)",
    location: {
      mapTitle: "Confirmar ubicación",
      mapConfirm: "Confirmar ubicación",
      mapHint: "Mueve el mapa para ajustar el pin sobre la dirección exacta",
      locationCardHint: "Confirma la ubicación en el mapa para continuar",
      locationConfirmed: "Ubicación confirmada",
      adjustOnMap: "Ajustar en mapa",
      selectCityFirst: "Selecciona una ciudad primero",
      confirmOnMapRequired: "Pendiente de confirmar en mapa",
    },
  },
  checkout: {
    title: "Confirmar envío",
    summary: "Resumen",
    confirm: "Crear envío",
    pay: "Ir a pagar",
    recreate: "Reintentar creación",
    error: "Error al crear el envío",
    success: "Envío creado correctamente",
    addressesTitle: "Direcciones",
    addressesSubtitle: "Origen y destino del envío",
    originAddress: "Dirección de origen",
    destinationAddress: "Dirección de destino",
    informationTitle: "Información del envío",
    clientName: "Nombre del cliente",
    clientPhone: "Teléfono del cliente",
    orderDetail: "Detalle del pedido",
    productsCount: "Productos ({{count}})",
    costTitle: "Costo del envío",
    subtotal: "Subtotal",
    total: "Total",
    linkedOrder: "Pedido #{{orderId}}",
    payTitle: "Pago del envío",
    paymentMethod: "Método de pago",
    cancelAddCard: "Cancelar",
    termsPrefix: "Al realizar este pago estás de acuerdo con los",
    termsSuffix: "de la plataforma",
  },
  detail: {
    title: "Detalle del envío",
    status: "Estado",
    tracking: "Rastrear envío",
    guide: "Ver guía",
    manifest: "Ver manifiesto",
    pay: "Pagar envío",
    cancel: "Cancelar envío",
    cancelConfirm: "¿Estás seguro de cancelar este envío?",
    refresh: "Actualizar",
    support: "Contactar soporte",
    customer: "Cliente",
    cost: "Costo del envío",
  },
  orders: {
    createShipment: "Crear envío",
    viewShipment: "Ver envío",
  },
  logisticStates: {
    notCreated: "No creado",
    calculated: "Cotizado",
    created: "Creado",
    assigned: "Asignado",
    pendingPayment: "Pendiente de pago",
    successPayment: "Pago exitoso",
    pending: "Pendiente",
    inProgress: "En curso",
    finished: "Finalizado",
    cancelled: "Cancelado",
    error: "Error",
  },
};

export default delivery;
